export default __webpack_public_path__ + "img/722da37a0646181d98fa2708259916a4.jpg";